import React, { useEffect, useState } from 'react';
import { Drawer, DrawerHeader, DrawerBody, DrawerFooter, Button } from '@one-thd/sui-atomic-components';
import { DateCalendar } from '@one-thd/sui-date-pickers';

export interface CustomRangeDrawerProps {
  open: boolean;
  value?: string;
  onBack: () => void;
  onApply: (isoDate: string) => void;
}

const toIsoDate = (value: unknown): string | undefined => {
  if (!value) {
    return undefined;
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  const parsed = value instanceof Date ? value : new Date(value as any);
  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }

  const year = parsed.getFullYear();
  const month = parsed.getMonth();
  const day = parsed.getDate();
  return new Date(Date.UTC(year, month, day)).toISOString().slice(0, 10);
};

export const CustomRangeDrawer: React.FC<CustomRangeDrawerProps> = ({ open, value, onBack, onApply }) => {
  const [selectedDate, setSelectedDate] = useState<string | undefined>(value);

  useEffect(() => {
    if (open) {
      setSelectedDate(value);
    }
  }, [open, value]);

  return (
    <Drawer open={open} onClose={onBack} role="dialog" aria-modal="true" aria-label="Custom Range">
      <DrawerHeader title="Custom Range" onBack={onBack} onClose={onBack} />
      <DrawerBody>
        <DateCalendar
          value={selectedDate}
          onChange={(_event: unknown, nextValue: unknown) => setSelectedDate(toIsoDate(nextValue))}
        />
      </DrawerBody>
      <DrawerFooter>
        <Button
          variant="primary"
          fullWidth
          disabled={!selectedDate}
          onClick={() => {
            if (selectedDate) {
              onApply(selectedDate);
            }
          }}
        >
          Apply
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};
